import React from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../Util";
import { Card, Button } from "react-bootstrap";
import Rating from "../Components/Rating";
import { useContext } from "react";
import { Store } from "../Store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Product.css";

function Product(props) {
  const { product } = props;
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    cart: { cartItems },
  } = state;

  const addToCartHandler = async (item) => {
    const existItem = cartItems.find((x) => x._id === product._id);
    const quantity = existItem ? existItem.quantity + 1 : 1;
    const { data } = await axiosInstance.get(`/api/products/${item._id}`);
    if (data.countInStock < quantity) {
      window.alert("Sorry. Product is out of stock");
      return;
    }
    ctxDispatch({
      type: "CART_ADD_ITEM",
      payload: { ...item, quantity },
    });

    // Show toast notification
    toast.success("Added to cart! Check out.");
  };

  const originalPrice = product.price / (1 - product.discountPercentage / 100);
  const discountPrice =
    originalPrice - (originalPrice * product.discountPercentage) / 100;

  return (
    <>
      <Card>
        <Link to={`/product/${product.slug}`}>
          <img
            src={product.image}
            className='card-img-top product-image'
            alt={product.name}
          />
        </Link>
        <Card.Body>
          <Link to={`/product/${product.slug}`}>
            <Card.Title>{product.name}</Card.Title>
          </Link>
          <Rating rating={4} numReviews={product.numReviews} />

          <Card.Text>
            {product.discountPercentage > 0 ? (
              <>
                <span className='discounted-price'>
                  ${discountPrice.toFixed(2)}
                </span>{" "}
                <span className='original-price'>
                  &{originalPrice.toFixed(2)}
                </span>
              </>
            ) : (
              <span>${product.price}</span>
            )}
          </Card.Text>

          {product.countInStock === 0 ? (
            <Button variant='light' disabled>
              Out of stock
            </Button>
          ) : (
            <Button onClick={() => addToCartHandler(product)}>
              Add to cart
            </Button>
          )}
        </Card.Body>
      </Card>
      {/* Toast Container at the bottom */}
      <ToastContainer position='bottom-center' limit={1} />
    </>
  );
}

export default Product;
